import {Box, Button, Heading, Text} from 'grommet';
import {Home, Location} from "grommet-icons";
import React from "react";

function NotFound() {
    return (
        <Box pad="medium">
            <Heading level={1}>404</Heading>
            <Text>Oooops ti sei perso!</Text>
            <Button icon={<Home/>} hoverIndicator href={"/webapp"}  label={"HomePage"}/>
        </Box>
    );
}

export default NotFound;
